export default __webpack_public_path__ + "static/media/loader-blue-thin.82284360.svg";